import { Injectable } from '@angular/core';

import { RestService } from "../../core/services/rest.service";
import { apiName, eventosRastreamentoApiName } from "./data.service";

@Injectable()
export class RastreamentoApiService {
    constructor(
        private _restService: RestService
    ) { }

    onGetCurrent(bemId: number, done: any) {
        this._restService.onGet(apiName + '/bem/' + bemId, done);
    }

    onGetPeriod(query: number, done: any) {
        this._restService.onGetPostCustom(apiName + '/bem/periodo', query, done);
    }

    onGetAll(query: any, done: any) {
        this._restService.onGetPost(apiName, query, done);
    }

    //eventos
    onGetByQuery(query: any, done: any) {
        this._restService.onGetPostCustom(eventosRastreamentoApiName + '/populado', query, done);
    }

    onGetAllEvents(done: any) {
        this._restService.onGetSemSchema(eventosRastreamentoApiName + '/listar-tipos-eventos', done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/shared/rastreamento-api.service.ts
 **/